// src/components/Sections/ContactSection/ContactSection.jsx

import React from 'react';
import './ContactSection.scss';

export default function ContactSection({
  formData,
  formStatus,
  handleInputChange,
  handleSubmit
}) {
  return (
    <section
      id="contact"
      className="section section--contact"
    >
      <div className="container contact-section">
        <div className="contact-section__intro">
          <p className="kicker">
            Founding Members · GTA · 2027
          </p>

          <h2>
            Be part of the founding class.
          </h2>

          <p>
            Request Founding Membership ahead of the 2027 season, suggest
            a public course, or tell us about a potential partnership.
            This form is an inquiry—not a payment or confirmed membership.
          </p>

          <div className="contact-section__points">
            <span>Founding list</span>
            <span>Course partnerships</span>
            <span>Community partnerships</span>
            <span>Course submissions</span>
          </div>
        </div>

        <div className="contact-card">
          <form
            className="contact-form"
            onSubmit={handleSubmit}
          >
            <input
              type="hidden"
              name="sourcePage"
              value="homepage"
            />

            <div
              className="contact-form__honeypot"
              aria-hidden="true"
            >
              <label htmlFor="ttg_middle_name_check">
                Leave this field blank
              </label>

              <input
                id="ttg_middle_name_check"
                name="ttg_middle_name_check"
                type="text"
                tabIndex="-1"
                autoComplete="new-password"
                value={formData.ttg_middle_name_check}
                onChange={handleInputChange}
              />
            </div>

            <div className="contact-form__field">
              <label htmlFor="inquiryType">
                I'm interested in
              </label>

              <select
                id="inquiryType"
                name="inquiryType"
                value={formData.inquiryType}
                onChange={handleInputChange}
                required
              >
                <option value="founding_membership">
                  Founding Membership
                </option>

                <option value="partnership">
                  Partnership
                </option>

                <option value="add_course">
                  Add a Course
                </option>

                <option value="contact">
                  General Question
                </option>
              </select>
            </div>

            <div className="contact-form__grid">
              <div className="contact-form__field">
                <label htmlFor="fullName">
                  Full Name
                </label>

                <input
                  id="fullName"
                  name="fullName"
                  type="text"
                  placeholder="Your name"
                  value={formData.fullName}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="contact-form__field">
                <label htmlFor="email">
                  Email
                </label>

                <input
                  id="email"
                  name="email"
                  type="email"
                  placeholder="you@example.com"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            <div className="contact-form__field">
              <label htmlFor="city">
                City
              </label>

              <input
                id="city"
                name="city"
                type="text"
                placeholder="Toronto, Mississauga, Oakville..."
                value={formData.city}
                onChange={handleInputChange}
              />
            </div>

            <div className="contact-form__field">
              <label htmlFor="message">
                Message
              </label>

              <textarea
                id="message"
                name="message"
                rows="6"
                placeholder="Tell us how you'd like to get involved with The Tour."
                value={formData.message}
                onChange={handleInputChange}
                required
              />
            </div>

            {formStatus.success ? (
              <div className="contact-form__status contact-form__status--success" role="status">
                {formStatus.success}
              </div>
            ) : null}

            {formStatus.error ? (
              <div className="contact-form__status contact-form__status--error" role="alert">
                {formStatus.error}
              </div>
            ) : null}

            <button
              className="button button--primary contact-form__submit"
              type="submit"
              disabled={formStatus.loading}
            >
              {formStatus.loading
                ? 'Sending...'
                : formData.inquiryType === 'founding_membership'
                  ? 'Request Founding Membership'
                  : 'Send Inquiry'}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}